import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgSaveIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.6}
    >
      <path d="M50.667 56H13.333A5.333 5.333 0 0 1 8 50.667V13.333A5.333 5.333 0 0 1 13.333 8h29.334L56 21.333v29.334A5.333 5.333 0 0 1 50.667 56" />
      <path d="M45.334 56V34.667H18.667V56M18.667 8v13.333H40" />
    </g>
  </svg>
)
export default SvgSaveIcon
